import JwtDecode from 'jwt-decode'

export default class Auth {
  static from (token) {
    try {
      console.log( "Check Token", token )
      let obj = JwtDecode(token)
      
      if ( Math.floor(Date.now() / 1000) < obj.exp ) {
        console.log( obj )
        return new Auth(obj)
      } else {
        console.log( "Token expired!" )
        console.log( Math.floor(Date.now() / 1000) )
        console.log( obj.exp )
        localStorage.token = null
        return false
      }
      
    } catch (_) {
      console.log( "Token Error", _ );
      localStorage.token = null;
      return null
    }
  }

  constructor ({ user_id, admin, email, name, exp, level, day_ends_at }) {
    this.id     = user_id // eslint-disable-line camelcase
    this.admin  = admin
    this.email  = email
    this.name   = name
    this.exp    = new Date(exp * 1000)
    this.level  = level
    this.day_ends_at = day_ends_at
  }

  get isAdmin () {
    return this.admin
  }
}
